import React from 'react';
import PropTypes from 'prop-types';
import Glyph from 'kepler/lib/components/Glyph';
import getContent from '../lib/dictionaryFetcher';

const SearchForm = props => {
  const { search, handleSearch, clearSearch } = props;

  return (
    <div id="tools-search-form">
      <input
        id="tools-search"
        type="text"
        placeholder={getContent('merchanthub', 'search.enter')}
        name="tools-search"
        onChange={handleSearch}
        value={search}
      />
      <span className="leadingNodes">
        <span
          className="leadingNode"
          style={{ display: search ? 'block' : 'none' }}
          onClick={clearSearch}
          onKeyDown={e => e.keyCode === 13 && clearSearch()}
          role="presentation"
        >
          <Glyph type="default" icon={'icon-close-small'} />
        </span>
        <span
          className="leadingNode"
          style={{ display: search ? 'none' : 'block' }}
        >
          <Glyph type="default" icon={'icon-magnifying-glass'} />
        </span>
      </span>
    </div>
  );
};

SearchForm.propTypes = {
  search: PropTypes.string,
  handleSearch: PropTypes.func,
  clearSearch: PropTypes.func
};

export default SearchForm;
